import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface AppSliceState {
  loading: boolean;
}

const initialState: AppSliceState = {
  loading: false,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setAppLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const { setAppLoading } = appSlice.actions;
export default appSlice.reducer;

// Selector
export const getAppLoading = (state: { app: AppSliceState }) =>
  state.app.loading;
